import { api } from '@/api';
import { api_routes } from '@/api-routes';

/**
 * Busca un deportista existente por DNI para renovación.
 * @param {number} listaId
 * @param {string} dni
 * @returns {Promise<AxiosResponse>}
 */
export function buscarBase(listaId, dni) {
    const hashTeatro = localStorage.getItem('hash_teatro');
    return api.call(
        api_routes['front.bases.buscar'],
        { filters: { tid: hashTeatro, dni } },
    );
}

// Re-exportamos todas las funciones compartidas con el flujo de crear
export {
    getCategorias,
    getEquipos,
    guardarDatos,
    guardarResponsables,
    guardarDocumentos,
    getIndumentarias,
    bloquearIndumentarias,
    guardarDescuentos,
    crearBase,
    calcularPlazos,
    borrarPlazos,
} from './crearDeportista';
